module.exports = __webpack_public_path__ + "static/media/LivingClassAdmin_001.c45af34d.png";